import { React, useState } from "react";
// import ContactForm from "../ContactFrom/ContactForm";
import "./index.css";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const GOOGLE_FORM_URL = "https://docs.google.com/forms/d/e/1FAIpQLScc7IRLP1fR3vGajDMmzkIktC3G5JpS3X3DKzEH28yKls-J0g/formResponse";
const ENTRY_IDS = {
  name: "entry.1736748249",
  email: "entry.1860212509",
  subject: "entry.1173645858",
  message: "entry.1356356201",
};

const Contactpage = () => {
  const [formDetails, setFormDetails] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormDetails((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const isFormIncomplete = Object.values(formDetails).some((value) => value === "");
    if (isFormIncomplete) {
      toast.error("Please fill all the fields.");
      return;
    }
    const formData = new FormData();
    formData.append(ENTRY_IDS.name, formDetails.name);
    formData.append(ENTRY_IDS.email, formDetails.email);
    formData.append(ENTRY_IDS.subject, formDetails.subject);
    formData.append(ENTRY_IDS.message, formDetails.message);
    fetch(GOOGLE_FORM_URL, {
      method: "POST",
      mode: "no-cors",
      body: formData,
    })
      .then(() => {
        toast.success("Form submitted successfully!");
        setFormDetails({
          name: "",
          email: "",
          subject: "",
          message: "",
        });
      })
      .catch((error) => {
        console.error("Error submitting form:", error);
        toast.error("There was an error submitting the form. Please try again.");
      });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && e.target.tagName !== "TEXTAREA") {
      e.preventDefault(); // Stops Enter from submitting the form
    }
  };

  return (
    <section className="wpo-contact-pg-section">
      <section className="wpo-contact-map-section position-relative contact-us-page-map">
        <div className="contactus-form p-3">
          <div className="contactus-form-inner-1">
            <h4 className="text-white">Contact Information</h4>
            <p className="text-white">
              We will develop top-notch, engaging content and design a journey
              map to highlight your accomplishments
            </p>
            <div className="d-flex flex-column justify-content-between gap-4 mt-4">
              <span className="text-white d-flex gap-4">
                <LocalPhoneOutlinedIcon /> +44 033011 32233
              </span>
              <span className="text-white d-flex gap-4">
                <MailOutlineIcon /> info@europasolutions.co.uk
              </span>
              <span className="text-white d-flex gap-4">
                <LocationOnOutlinedIcon />
                18 Lincoln Drive, Houlton, Rugby, England, CV23 1BS
              </span>
            </div>
          </div>
          <form
            className="contactus-form-inner-2"
            onSubmit={handleSubmit}
            onKeyDown={handleKeyDown}
          >
            <div className="d-flex gap-4">
              <div className="w-50">
                <span className="text-white">Your Name</span>
                <br />
                <input
                  name="name"
                  value={formDetails.name}
                  onChange={handleChange}
                  type="text"
                  placeholder="Name Surname"
                  className="card-input w-100 mt-1"
                  required
                />
              </div>
              <div className="w-50">
                <span className="text-white">Your email</span>
                <br />
                <input
                  name="email"
                  value={formDetails.email}
                  onChange={handleChange}
                  type="email"
                  placeholder="example@gmail.com"
                  className="card-input w-100 mt-1"
                  required
                />
              </div>
            </div>
            <div>
              <span className="text-white mb-4">Subject</span>
              <br />
              <input
                name="subject"
                value={formDetails.subject}
                type="text"
                onChange={handleChange}
                placeholder="I want to get query about..."
                className="card-input w-100 mt-1"
                required
              />
            </div>
            <div>
              <span className="text-white">Message</span>
              <br />
              <textarea
                name="message"
                value={formDetails.message}
                type="text" 
                rows={2}
                onChange={handleChange}
                placeholder="Write your message here..."
                className="card-input w-100 mt-1"
                style={{ height: "90px", resize: "none", padding: "8px" }}
                required
              />
            </div>
            <button
              className="form-submit-button align-self-start"
              type="submit"
            >
              Send Message
            </button>
          </form>
        </div>
        <div className="wpo-contact-map">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d19891.18154744242!2d-0.127647!3d51.507351!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48761b20e48c02d7%3A0x8b0c8cfc9f61b8ff!2sLondon%2C%20UK!5e0!3m2!1sen!2sbd!4v1587535240489"></iframe>
        </div>
      </section>
      <ToastContainer />
    </section>
  );
};

export default Contactpage;
